const SLIDE_OBJECT_CHROME_FIELD_SELECTOR = [
  '.cp-program-slide-canvas-toolbar',
  '.cp-program-slide-canvas-image-toolbar',
  '.cp-program-slide-canvas-video-toolbar',
  '.cp-evaluation-plan-sheet-table-edit-mini-modal',
].join(',');

/** 슬라이드 툴바·가림막 등 개체 크롬 필드. 여기선 텍스트가 아니라 개체를 복사한다. */
export function isSlideChromeFormControl(el: EventTarget | null): boolean {
  if (el instanceof HTMLSelectElement) return true;
  if (el instanceof HTMLInputElement) {
    if (el.readOnly || el.disabled) return true;
    const type = (el.type || 'text').toLowerCase();
    return (
      type === 'number' ||
      type === 'color' ||
      type === 'range' ||
      type === 'checkbox' ||
      type === 'radio' ||
      type === 'file' ||
      type === 'button' ||
      type === 'submit'
    );
  }
  if (el instanceof HTMLTextAreaElement) return el.readOnly || el.disabled;
  return false;
}

/** 플로팅 툴바·표 미니모달처럼 개체 속성을 고치는 필드 */
export function isSlideObjectChromeField(el: EventTarget | null): boolean {
  if (!(el instanceof HTMLElement)) return false;
  return !!el.closest(SLIDE_OBJECT_CHROME_FIELD_SELECTOR);
}

export const SLIDE_BLOCK_CLIP_PREFIX = 'cp-slide-block:v1:';
export const SLIDE_BLOCKS_CLIP_PREFIX = 'cp-slide-blocks:v1:';

export function isSlideBlockClipboardText(text: string): boolean {
  const t = (text ?? '').trim();
  return t.startsWith(SLIDE_BLOCK_CLIP_PREFIX) || t.startsWith(SLIDE_BLOCKS_CLIP_PREFIX);
}

function isFullySelectedFormValue(el: HTMLInputElement | HTMLTextAreaElement): boolean {
  const len = el.value?.length ?? 0;
  if (len <= 0) return false;
  return el.selectionStart === 0 && el.selectionEnd === len;
}

/** 가림막·도형 등 읽기 전용 크롬 필드는 개체 복사. 실제 텍스트 선택만 네이티브. */
export function shouldDeferToNativeSlideCopy(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable || target.closest('[contenteditable="true"]')) {
    const sel = typeof window !== 'undefined' ? window.getSelection() : null;
    return !!(sel && !sel.isCollapsed && sel.toString());
  }
  if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) {
    if (isSlideChromeFormControl(target)) return false;
    if (target.selectionStart === target.selectionEnd) return false;
    // 툴바 URL·정답은 포커스 시 전체가 선택되는 경우가 많아 개체 복사를 우선한다.
    if (isSlideObjectChromeField(target) && isFullySelectedFormValue(target)) return false;
    return true;
  }
  return false;
}

/** 편집 중인 텍스트 필드만 네이티브 붙여넣기. 읽기 전용 가림막 textarea는 개체 붙여넣기. */
export function shouldDeferToNativeSlidePaste(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable || target.closest('[contenteditable="true"]')) return true;
  if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) {
    if (isSlideChromeFormControl(target)) return false;
    return true;
  }
  return false;
}
